import { ReactNode } from 'react';
import { FolderOutlined } from '@ant-design/icons';
import { Breadcrumb } from 'antd';
import styled from 'styled-components';

type FileExpolrerBreadCrumbItem = {
  icon?: ReactNode;
  id: string;
  name: string;
};

type FileExplorerBreadCrumbProps<TItem> = {
  items: TItem[];
  loading?: boolean;
  onSelect?: (index: number, item: TItem, nextItems: TItem[]) => void;
};

const StyledBreadcrumb = styled(Breadcrumb)`
  margin: 16px 0;
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 4px;
  ol {
    flex-wrap: unset;
  }
  li {
    min-width: 0;
  }
  .anticon {
    margin-right: 8px;
  }
  .ant-breadcrumb-item {
    align-items: center;
  }
  .ant-breadcrumb-separator {
    margin: 0 12px;
    color: rgba(0, 0, 0, 0.45);
    display: inline-flex;
    align-items: center;
    line-height: 24px;
    vertical-align: middle;
  }
  .ant-breadcrumb-link {
    cursor: ${({ params }) => (params?.loading ? 'not-allowed' : 'pointer')};
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    &:hover {
      color: #40a9ff;
    }
  }
`;

export function FileExplorerBreadCrumb<
  TItem extends FileExpolrerBreadCrumbItem,
>({ items, loading, onSelect }: FileExplorerBreadCrumbProps<TItem>) {
  return (
    <StyledBreadcrumb params={{ loading }} separator=">">
      {items.map((item, index) => {
        const nextItems = items.slice(0, index + 1);
        return (
          <StyledBreadcrumb.Item
            key={item.id}
            onClick={() => onSelect?.(index, item, nextItems)}
          >
            {item.icon ?? <FolderOutlined />}
            {item.name}
          </StyledBreadcrumb.Item>
        );
      })}
    </StyledBreadcrumb>
  );
}
